// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__TgUFu","summary":"CartItem_summary__1TF20","price":"CartItem_price__2RRMp","amount":"CartItem_amount__1zRjN","actions":"CartItem_actions__3Jeqv"};